import { X } from 'lucide-react';
import React from 'react';

const LegalModal = ({ isOpen, onClose, content }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/20 backdrop-blur-sm z-[200] flex items-center justify-center">
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-3xl max-h-[80vh] overflow-hidden">
        <div className="p-6 border-b border-gray-100 flex items-center justify-between sticky top-0 bg-white">
          <h2 className="text-xl font-semibold">{content.title}</h2>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
        <div className="p-6 overflow-y-auto max-h-[calc(80vh-80px)]">
          {content.type === 'terms' && (
            <div>
              <section>
                <h3 className="text-lg font-semibold mb-3">Terms of Service</h3>
                <div className="space-y-4 text-gray-600">
                  <p>
                    Last updated: January 20, 2025
                    Welcome to Skillhub! These Terms of Service (“Terms”)
                    govern your access to and use of Skillhub’s platform,
                    including its website, mobile applications, and any related
                    services (collectively referred to as the “Service”). By
                    accessing or using the Service, you agree to these Terms.
                    If you do not agree, do not use the Service.<br />
                  </p>
                  {/* Insert extended Terms of Service content here */}
                  

                        <br />
                        Welcome to Skillhub! These Terms of Service (“Terms”) govern your access to and use of Skillhub’s platform, including its website, mobile applications, and any related services (collectively referred to as the “Service”). By accessing or using the Service, you agree to these Terms. If you do not agree, do not use the Service.
                        <br /><br />

                        <div>
                        <h2 className="text-2xl font-bold mb-4">1. Using Skillhub</h2>
                        <h3 className="text-xl font-bold mb-2 pl-8">a. Eligibility</h3>
                        </div>
                        You must be at least 13 years old to use Skillhub. By using the Service, you confirm that you meet this requirement.
                        <br /><br />
                        If you’re under the age required to manage your own Skillhub account, you must have your parent or legal guardian’s permission to use a Skillhub account. Please have your parent or legal guardian read these terms with you.
                        <br />
                        <div>
                        <h3 className="text-xl font-bold mb-2 pl-8">b. Your Account</h3>
                        </div>                        
                        To access certain features of Skillhub, you may need to create an account. You agree to:
                        <br /><br />
                        1. Provide accurate, up-to-date information during registration.
                        <br />
                        2. Maintain the confidentiality of your account credentials.
                        <br />
                        3. Notify us immediately if you suspect unauthorized use of your account.
                        <br /><br />
                        Skillhub reserves the right to suspend or terminate your account if any information provided is inaccurate or violates these Terms.
                        <br />
                        <h2 className="text-2xl font-bold mb-4">2. Content on Skillhub</h2>
                        <h3 className="text-xl font-bold mb-2 pl-8">a. Your Content</h3>
                        <br />
                        You retain ownership of the content you create or upload to Skillhub (“Your Content”). By posting Your Content, you grant Skillhub a worldwide, non-exclusive, royalty-free license to use, reproduce, distribute, and display it in connection with the Service.
                        <br />
                        <h3 className="text-xl font-bold mb-2 pl-8">b. Prohibited Content</h3>
                        <br />
                        You agree not to post or share content that:
                        <br /><br />
                        1. Violates any law or regulation.
                        <br />
                        2. Infringes on intellectual property rights.
                        <br />
                        3. Contains harmful, abusive, or hateful material.
                        <br /><br />
                        Skillhub reserves the right to remove any content that violates these Terms.
                        <br />
                        <h2 className="text-2xl font-bold mb-4">3. Privacy</h2>
                        <br />
                        Your use of Skillhub is subject to our Privacy Policy, which explains how we collect, use, and protect your information. By using the Service, you consent to the collection and use of your information as described in the Privacy Policy.
                        <br />
                        <h2 className="text-2xl font-bold mb-4">4. Payments and Refunds</h2>
                        <br />
                        <h3 className="text-xl font-bold mb-2 pl-8">a. Payment Terms</h3>
                        <br />
                        Some features of Skillhub may require payment. By providing payment information, you authorize Skillhub to charge the applicable fees. All payments are processed securely through third-party payment providers.
                        <br />
                        <h3 className="text-xl font-bold mb-2 pl-8">b. Refund Policy</h3>
                        <br />
                        Refunds are subject to Skillhub’s refund policy, available on our website. Certain purchases may be non-refundable.
                        <br />
                        <h2 className="text-2xl font-bold mb-4">5. Modifications to the Service</h2>
                        <br />
                        Skillhub may modify or discontinue any part of the Service at any time without prior notice. We are not liable for any modifications or interruptions to the Service.
                        <br />
                        <h2 className="text-2xl font-bold mb-4">6. Termination</h2>
                        <br />
                        We reserve the right to suspend or terminate your access to Skillhub if you violate these Terms or engage in any activity that disrupts the Service.
                        <br />
                        <h2 className="text-2xl font-bold mb-4">7. Disclaimer and Limitation of Liability</h2>
                        <br />
                        The Service is provided “AS IS” without warranties of any kind. Skillhub is not liable for any indirect, incidental, or consequential damages arising from your use of the Service.
                        <br />
                        <h2 className="text-2xl font-bold mb-4">8. Governing Law</h2>
                        <br />
                        These Terms are governed by the laws of the jurisdiction where Skillhub operates.
                        <br />
                        For questions or support, please contact support@skillhub.com.
                </div>
              </section>
            </div>
          )}

          {content.type === 'privacy' && (
            <div>
              <section>
                <h3 className="text-lg font-semibold mb-3">Privacy Policy</h3>
                <div className="space-y-4 text-gray-600">
                  <p>
                    Skillhub values your privacy. This Privacy Policy explains
                    how we collect, use, and protect your information when you
                    use our Service.
                  </p>
                  <h2 className="text-2xl font-bold mb-4">Information We Collect</h2>
                  <h3 className="text-xl font-bold mb-2 pl-8">a. Information You Provide</h3>
                  <br />
                    We collect information you provide directly to us, such as:
                  <br />
                    1. Account details: Name, email, and profile information.
                    2. Payment details: Billing information for purchases (processed securely).
                    3. Content: Any material you upload or create on Skillhub.
                    <h3 className="text-xl font-bold mb-2 pl-8">b. Information We Collect Automatically</h3>
                    <br />
                    When you use Skillhub, we may collect information such as:
                    <br />
                    1. Device and usage data: IP address, browser type, and operating system.
                    2. Interaction data: Pages viewed, time spent, and features used.
                    3. Cookies: Data stored to enhance your experience (see our Cookie Policy).
                    <br />                    
                    <h3 className="text-xl font-bold mb-2 pl-8">c. Information from Third Parties</h3>
                    <br />                    
                    We may receive information from third-party services, such as payment processors or social media platforms, if you connect those accounts to Skillhub.
                    <br /><br />
                    For questions or support, please contact support@skillhub.com.
                </div>
              </section>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default LegalModal;